import { Card } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { QueryFilter, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useComponentVisible } from 'hooks';

import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { useTranslation } from 'react-i18next';

import { useGetContracts } from 'services/contract';

import LabeledContractStatus from 'components/molecules/labeledStatus/LabeledContractStatus';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import { useScroll } from 'components/templates/application/ApplicationTemplate';
import { useStoreState } from 'providers/StoreStateContext';
import { useNavigate } from 'react-router-dom';
import { IContractListItemResponse, IContractSearch, PRODUCT_TYPE } from 'services/contract/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { useEnumToSelectOptions } from 'utils/components/inputs/select';
import { formatDateToInput } from 'utils/global/date.utils';
import { getNodes } from 'utils/table/nodes.utils';
import QueryFilterLabels from 'components/organisms/filters/query-form/labels/QueryFilterLabels';

enum COLUMNS {
  title,
  startDate,
  endDate,
  status,
}

const contractsSearchInitialValues: IContractSearch = {
  ShowOnlyActive: false,
};

const Contracts = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { searchById, setSearchById } = useStoreState();

  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);

  const columnsVisibility = useTableColumnsVisibility('Contracts', COLUMNS);

  const filters = searchById[columnsVisibility.tableId] || contractsSearchInitialValues;

  const { data, isLoading, fetchNextPage, isFetchingNextPage } = useGetContracts(filters);

  const tableData = getNodes<IContractListItemResponse>(data?.pages.flat());

  const { getSelectOptions } = useEnumToSelectOptions();

  const scroll = useScroll({ fetchNextPage: fetchNextPage });

  return (
    <TopbarPage
      topbarAbsolute
      topbar={
        <TopBar
          title={t(`navbar.contracts`)}
          path=""
          customBackItem={<div />}
          topbarContent={
            <div className="flex">
              <QueryFilter.ButtonOpener
                i18nextPrefix={''}
                onClick={handleComponentVisible}
                variant={BUTTON_VARIANT.default}
                isClear
              />

              {/* <Table.CustomColumnsButton
                columns={COLUMNS}
                isClear
                visibility={columnsVisibility}
                customI18next=""
                i18nextPrefix={"input.label"}
              /> */}
            </div>
          }
        >
          {' '}
          <QueryFilter<IContractSearch> i18nextPrefix={'input.label'} initialValues={filters}>
            <>
              <QueryFilter.Form<IContractSearch>
                ref={ref}
                isOpen={isComponentVisible}
                onDebouncedFormChange={(values) => setSearchById(columnsVisibility.tableId, values)}
              >
                <QueryFilter.InputsGrid>
                  <FormInput.Select
                    name="ProductType"
                    label={t('input.label.productType')}
                    options={getSelectOptions(PRODUCT_TYPE, 'enum.PRODUCT_TYPE')}
                    appBackground
                  />
                  <FormInput.Checkbox
                    name="ShowOnlyActive"
                    label={t('input.label.showOnlyActive')}
                    appBackground
                  />
                </QueryFilter.InputsGrid>
              </QueryFilter.Form>
              <QueryFilterLabels scope="contracts" isFormOpen={isComponentVisible} />
            </>
          </QueryFilter>
        </TopBar>
      }
    >
      <ListWrapper
        view="list"
        items={data?.pages.flat()}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        item={(contract) => (
          <Card
            view="list"
            key={contract.id}
            header={contract.title}
            onClick={() => navigate(`/contracts/${contract.id}/form`)}
            description={
              contract.endDate
                ? `${formatDateToInput(
                    contract.startDate,
                  )} - ${formatDateToInput(contract.endDate)}`
                : formatDateToInput(contract.startDate)
            }
            status={<LabeledContractStatus status={contract.status} onlyIcon />}
          />
        )}
      />
      {/* <Table
        id={columnsVisibility.tableId}
        loading={isLoading || isFetchingNextPage}
        onFullyScroll={fetchNextPage}
        displayMode
        data={tableData}
        columns={[
          {
            label: t(`input.label.title`),
            renderCell: ({ title }) => (
              <TableItem>
                <TableItem.Text text={title} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(COLUMNS.title),
          },

          {
            label: t("input.label.startDate"),
            renderCell: ({ startDate }) => (
              <TableItem>{formatDate(startDate)}</TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(COLUMNS.startDate),
          },
          {
            label: t("input.label.endDate"),
            renderCell: ({ endDate }) => (
              <TableItem>{endDate ? formatDate(endDate) : "-"}</TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(COLUMNS.endDate),
          },
          {
            label: t("input.label.status"),
            renderCell: ({ status }) => (
              <TableItem justifyPosition="center">
                <LabeledContractStatus status={status} />
              </TableItem>
            ),
            hide: columnsVisibility.hide(COLUMNS.status),
          },
        ]}
      /> */}
    </TopbarPage>
  );
};

export default Contracts;
